import { WatchlistDetailNoteType } from './WatchlistDetailNoteType';

export const WatchlistDetailNoteTypeOptions = [
    {
        key: WatchlistDetailNoteType.Loan,
        name: 'Loan Note',
        display: '',
    },
    {
        key: WatchlistDetailNoteType.LoanProperty,
        name: 'Loan Property Note',
        display: '',
    },
    {
        key: WatchlistDetailNoteType.Entity,
        name: 'Entity Note',
        display: 'Entity',
    },
];
